import axios from 'axios'
import { Config, setErrorLog } from '../../api/axiosCreate'

// 안 읽은 공지사항 조회 (로그인 시)
function getNewPush (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'newPush', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function readPush (UserID, Password, ID, PushMutation) {
  const data = {
    UserID: UserID,
    Password: Password,
    ID: ID,
    PushMutation: PushMutation
  }
  return axios.post(Config.baseUrl + 'readPush', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function deletePush (UserID, Password, ID, PushMutation) {
  const data = {
    UserID: UserID,
    Password: Password,
    ID: ID,
    PushMutation: PushMutation
  }
  return axios.post(Config.baseUrl + 'deletePush', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getPushListNoRead (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getPushListNoRead', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getSpecimenAlarm (UserID, Password, ManageGCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    ManageGCode: ManageGCode
  }
  return axios.post(Config.baseUrl + 'getSpecimenAlarm', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getInfoClientSpecimenAlarmList (UserID, Password, ManageGCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    ManageGCode: ManageGCode
  }
  return axios.post(Config.baseUrl + 'getInfoClientSpecimenAlarmList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getInfoClientLMSSend (UserID, Password, ClientID) {
  const data = {
    UserID: UserID,
    Password: Password,
    ClientID: ClientID
  }
  return axios.post(Config.baseUrl + 'getInfoClientLMSSend', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function setInfoClientGroupName (UserID, Password, ClientID, GroupName) {
  const data = {
    UserID: UserID,
    Password: Password,
    ClientID: ClientID,
    GroupName: GroupName
  }
  return axios.post(Config.baseUrl + 'setInfoClientGroupName', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function setInfoClientLMSSend (UserID, Password, LMSSendID, ClientID, LMSWeekDay, SendTime, ManagerID) {
  const data = {
    UserID: UserID,
    Password: Password,
    LMSSendID: LMSSendID,
    ClientID: ClientID,
    LMSWeekDay: LMSWeekDay,
    SendTime: SendTime,
    ManagerID: ManagerID
  }
  return axios.post(Config.baseUrl + 'setInfoClientLMSSend', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function delInfoClientLMSSend (UserID, Password, LMSSendID) {
  const data = {
    UserID: UserID,
    Password: Password,
    LMSSendID: LMSSendID
  }
  return axios.post(Config.baseUrl + 'delInfoClientLMSSend', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getUsersPushSet (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getUsersPushSet', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function setUsersPushSet (UserID, Password, IsReceivePush, PushSTime, PushETime) {
  const data = {
    UserID: UserID,
    Password: Password,
    IsReceivePush: IsReceivePush,
    PushSTime: PushSTime,
    PushETime: PushETime
  }
  return axios.post(Config.baseUrl + 'setUsersPushSet', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

export {
  getNewPush,
  getPushListNoRead,
  deletePush,
  getSpecimenAlarm,
  readPush,
  getUsersPushSet,
  setUsersPushSet,
  getInfoClientSpecimenAlarmList,
  getInfoClientLMSSend,
  setInfoClientGroupName,
  setInfoClientLMSSend,
  delInfoClientLMSSend
}
